/* eslint-disable camelcase */
import chainApis from 'api/chain'
import authApis from 'api/auth'
import { createApiHandler } from 'helpers/apiHandler'
import { Redux } from 'types/local'
import { createActionsSet } from 'utils/redux'
import { ACCESS_TOKEN } from 'api/client'
import { setCookie } from 'utils/cookies'
import appLoadingFeatureActions from 'feature/app-loading.actions'
import { projectActions } from '../CreateProject/create-project.actions'

const types = {
  GET_SUPPORTED_CHAINS: createActionsSet.api('header.get-supported-chains'),
  GET_SUPPORTED_AUDIT_PROVIDER: createActionsSet.api('header.get-supported-audit-provider'),
  SET_WALLET: 'header.set-wallet',
  SET_SELECTED_CHAIN: 'header.set-selected-chain',
  SET_TOKEN_INFO: 'header.set-token-info',
  SET_SIGNATURE: 'header.set-signature',
  SET_TOKEN: 'header.set-token',
  SET_USER: 'header.set-user-info',
  SET_SELECTED_ADDRESS: 'header.set-selected-address',
  SIGN_IN_CUSTOMER: createActionsSet.api('header.sign-in-customer'),
}
const getSupportedChains = () => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
  dispatch({ type: types.GET_SUPPORTED_CHAINS.REQUEST })
  dispatch(appLoadingFeatureActions.start())
  try {
    const handleApi = createApiHandler(dispatch, getState)
    const response = await handleApi(chainApis.getSupportedChain())
    dispatch({ type: types.GET_SUPPORTED_CHAINS.SUCCESS, payload: response })
  } catch (e) {
    dispatch(appLoadingFeatureActions.finish())
    dispatch({ type: types.GET_SUPPORTED_CHAINS.FAILED, payload: e })
  } finally {
    dispatch(appLoadingFeatureActions.finish())
  }
}

const getSupportedAuditProvider = () => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
  dispatch({ type: types.GET_SUPPORTED_AUDIT_PROVIDER.REQUEST })
  dispatch(appLoadingFeatureActions.start())
  try {
    const handleApi = createApiHandler(dispatch, getState)
    const response = await handleApi(chainApis.getSupportedAuditProvider())
    dispatch({
      type: types.GET_SUPPORTED_AUDIT_PROVIDER.SUCCESS,
      payload: response,
    })
  } catch (e) {
    dispatch(appLoadingFeatureActions.finish())
    dispatch({ type: types.GET_SUPPORTED_AUDIT_PROVIDER.FAILED, payload: e })
  } finally {
    dispatch(appLoadingFeatureActions.finish())
  }
}

const signin =
  ({
    message,
    signature,
    wallet,
    sponsor_address,
    message_sign,
    chainId,
    email,
    token,
  }: {
    chainId: number
    email?: string
    token?: string
    message: string
    signature: string
    wallet: string
    message_sign: string
    sponsor_address?: string
  }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({ type: types.SIGN_IN_CUSTOMER.REQUEST })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createApiHandler(dispatch, getState)
      const response = await handleApi(
        authApis.signinCustomer({
          message,
          signature,
          wallet,
          sponsor_address,
          message_sign,
        }),
      )
      dispatch({ type: types.SIGN_IN_CUSTOMER.SUCCESS, payload: response })

      setCookie(ACCESS_TOKEN, response.token, '30d')
      if (token && email) {
        dispatch(
          projectActions.createProject({
            chainId,
            email,
            tokenAddress: token,
            ownerAddress: wallet,
          }),
        )
      }
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.SIGN_IN_CUSTOMER.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }
export const headerActions = {
  types,
  getSupportedChains,
  signin,
  getSupportedAuditProvider,
}
